import React, { useContext, useState} from "react";
import { BankOwnerContext } from "./BankOwnerContext";
import {Link,Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';


export default function BankOwnerDashboard() {
    const { bankOwnerData} = useContext(BankOwnerContext);   
    const [dropdownVisible,setDropdownVisible]=useState(false)
    // console.log("bankOwnerData",bankOwnerData?.username)
          return (
        <div className="bg-gray-100  flex flex-col max-w-full min-w-fit max-h-full min-h-fit landing-page mt-20">
            <div className="relative max-w-40 min-w-fit"
                    onMouseEnter={() => setDropdownVisible(true)}
                    onMouseLeave={() => setDropdownVisible(false)}>
            <Link className=" hover:text-blue-500 flex flex-col max-w-40"  to="account">
              {bankOwnerData?.profile ? <img src={bankOwnerData?.profile} alt={bankOwnerData?.username} className=" h-12 w-12 rounded-full"/>:<FontAwesomeIcon className=" w-12 h-12 rounded-full" icon={faUser}/>}
            </Link>
           
            {dropdownVisible && 
               <div className="top-20 left-0 bg-white shadow-lg rounded-md p-4  max-w-40 min-w-fit  gap-x-6">
                 <Link to="/bankOwnerDash/account/change" className="block text-gray-700 hover:text-blue-500 mb-2">
                    <FontAwesomeIcon icon={faTachometerAlt}/>Account
                 </Link>

                 <Link to="/bankOwnerDash/account/logout" className="block text-gray-700 hover:text-blue-500 mb-2">
                    <FontAwesomeIcon icon={faSignOut}/>Logout
                 </Link>
               </div>
            }

            </div>
            <p className="text-blue-500 italic">Welcome {bankOwnerData?.username}</p>
            <h4 className="text-lg font-semibold mb-4">BANKS</h4>
            <div className=" flex flex-row space-x-2">
                <Link to="banks" className=" hover:bg-blue-500">Banks</Link>
                <Link to="communicate">Communicate</Link>
            </div>
            
            <Outlet/>
        </div>
    );
}


